// Whether the page is being left. Set on `pagehide`, which fires only once the
// user has gone past any "Leave site?" prompt. Requests still running then are
// cancelled by the browser, so their failures ("Load failed" in Safari) are not
// errors worth reporting. See FE-1454.
let unloading = false
// Set when the app itself navigates away after telling the user what happens to
// their edits, so the browser's leave prompt would only ask again.
let leavingOnPurpose = false

export const isPageUnloading = () => unloading

export const allowLeaving = () => {
  leavingOnPurpose = true
}

export const isLeavingOnPurpose = () => leavingOnPurpose

export const watchPageUnload = (target = window) => {
  target.addEventListener('pagehide', () => {
    unloading = true
  })
  // A page restored from the back/forward cache keeps running.
  target.addEventListener('pageshow', () => {
    unloading = false
    leavingOnPurpose = false
  })
}

// For Sentry's beforeSend: drop events raised while the page is being left.
export const dropWhilePageUnloads = (event) =>
  isPageUnloading() ? null : event
